// @ts-nocheck
import { Fragment, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useLazyQuery } from '@apollo/client'
import { CubeLoader } from '@/components/ui/cube-loader'
import ReportProgress from '@/components/reports/ReportProgress'
import { GET_CAMPAIGN_CATEGORIES, GET_REPORT_CATEGORIES } from '@/graphql/publisher-dashboard-queries'
import _ from 'lodash'

const ClassificationReport = () => {
    const { id } = useParams()
    const [data, setData] = useState(null)

    const { data: campaignData } = useQuery(GET_CAMPAIGN_CATEGORIES, {
        variables: id ? { where: { id } } : {},
        skip: !id,
    })

    const [getCategories, { data: categoriesData, loading }] = useLazyQuery(GET_REPORT_CATEGORIES)

    useEffect(() => {
        const raw = campaignData?.campaigns?.[0]?.categories
        if (!raw) return
        const aliases = _.map(JSON.parse(raw), (c) => c.toLowerCase())
        if (aliases.length === 0) return
        getCategories({ variables: { where: { alias_IN: aliases } } })
    }, [campaignData, getCategories])

    useEffect(() => {
        if (categoriesData?.categories && !loading) {
            const array = _.map(categoriesData.categories, (category) => ({
                name: category.name,
                audience: category.audience,
                ratio: category.ratio,
                softcolor: category.ratio < 50 ? 'primary' : 'success',
                color: category.ratio < 50 ? 'primary' : 'success',
                value: category.ratio,
            })).sort((a, b) => b.audience - a.audience)
            setData(array)
        }
    }, [categoriesData, loading])

    if (loading) return <CubeLoader size="sm" />

    return (
        <Fragment>
            <div className="card table-responsive border-0" data-aos="fade-up" data-aos-delay="600">
                <div className="card-header p-4">
                    <h6 className="card-title">Generative AI Classification by Sub Audiences</h6>
                </div>
                <div className="card-body p-0 overflow-auto">
                    {data && data.length > 0 && (
                        <div className="table-responsive">
                            <table className="table mb-0 table-striped" style={{ marginTop: '10px' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '50px' }}></th>
                                        <th className="small">
                                            <b>Sub Audiences</b>
                                        </th>
                                        <th className="small">
                                            <b>Audience</b>
                                        </th>
                                        <th className="small">
                                            <b>Ratio</b>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ width: '50px', height: '68px' }} className="align-middle">
                                                <div className="d-flex align-items-center">
                                                    <small className="mb-0">{index + 1}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <small>{item.name}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <small>{item.audience}</small>
                                            </td>
                                            <td>
                                                <div className="mb-2 d-flex align-items-center">
                                                    <small>{item.ratio}%</small>
                                                </div>
                                                <ReportProgress
                                                    softcolors={item.softcolor}
                                                    color={item.color}
                                                    className="shadow-none w-100"
                                                    value={item.value}
                                                    minvalue={0}
                                                    maxvalue={100}
                                                    style={{ height: '4px' }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default ClassificationReport
